import type { UserFilters } from '@/types'
import { request } from './client'

export async function getUserFilters(): Promise<UserFilters> {
  return request<UserFilters>('/user/filters')
}

export async function hideSet(setCode: string, idempotencyKey?: string): Promise<{ hiddenSet: string }> {
  return request('/user/filters/sets', {
    method: 'POST',
    body: { setCode },
    idempotencyKey,
  })
}

export async function unhideSet(setCode: string, idempotencyKey?: string): Promise<void> {
  await request<void>(`/user/filters/sets/${encodeURIComponent(setCode)}`, {
    method: 'DELETE',
    idempotencyKey,
  })
}

export async function hideCard(cardId: number, idempotencyKey?: string): Promise<{ hiddenCardId: number }> {
  return request('/user/filters/cards', {
    method: 'POST',
    body: { cardId },
    idempotencyKey,
  })
}

export async function unhideCard(cardId: number, idempotencyKey?: string): Promise<void> {
  await request<void>(`/user/filters/cards/${cardId}`, {
    method: 'DELETE',
    idempotencyKey,
  })
}

export async function hideRarity(
  setCode: string,
  rarity: string,
  idempotencyKey?: string,
): Promise<{ hiddenRarity: { setCode: string; rarity: string } }> {
  return request('/user/filters/rarities', {
    method: 'POST',
    body: { setCode, rarity },
    idempotencyKey,
  })
}

export async function unhideRarity(setCode: string, rarity: string, idempotencyKey?: string): Promise<void> {
  await request<void>(`/user/filters/rarities/${encodeURIComponent(setCode)}/${encodeURIComponent(rarity)}`, {
    method: 'DELETE',
    idempotencyKey,
  })
}

export async function hideSealedProduct(
  sealedProductId: number,
  idempotencyKey?: string,
): Promise<{ hiddenSealedProductId: number }> {
  return request('/user/filters/sealed_products', {
    method: 'POST',
    body: { sealedProductId },
    idempotencyKey,
  })
}

export async function unhideSealedProduct(sealedProductId: number, idempotencyKey?: string): Promise<void> {
  await request<void>(`/user/filters/sealed_products/${sealedProductId}`, {
    method: 'DELETE',
    idempotencyKey,
  })
}
